export const Colors = {
  black: '#000000',
  white: '#FFFFFF',
  mainBlack: '#1F1C2D',
  red: '#E5292E',
  silver: '#BCC6C9',
  grey: '#F0F2F5',
  green: '#32CD32',
}
